module.exports = __webpack_public_path__ + "static/media/en_suspens.fdac80cd.png";